import { FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable()
export class FormControlService {
  constructor() { }

  checkErrorInControl(control: FormControl) {
    let strMessage = '';

    if (control.hasError('required')) {
      strMessage = 'Este campo es requerido.';
    } else if (control.hasError('maxlength')) {
      console.log(control.getError);
      strMessage = 'El valor ingresado es muy largo.';
    } else if (control.hasError('minlength')) {
      strMessage = 'El valor ingresado es muy corto.';
    } else if (control.hasError('email')) {
      strMessage = 'Ingrese un email válido.';
    } else if (control.hasError('pattern')) {
      strMessage = `El valor ingresado no es válido.`;
    }

    return strMessage;
  }
}
